import { GetDistributionDetailsResponse, ProductTypeRequest } from "_clients/BFFClient";
import React from "react";

export type DashboardProps = {
	contractId: number;
	networkId : string;
	isHomePage : boolean;
	title?: string | React.ReactNode;
}


export const getProductTypeEnum = (productType: string) => {
	switch (productType) {
		case "BoostAlerte" :
			return ProductTypeRequest.BoostAlert;
		case "BoostListe":
			return ProductTypeRequest.BoostListe;
		case "BoostExtend":
			return ProductTypeRequest.BoostExtend;
		case "AnnonceOr":
			return ProductTypeRequest.AnnonceOr;
		case "AnnonceArgent":
			return ProductTypeRequest.AnnonceArgent;
		default:	
			return ProductTypeRequest.All;
	}
}

export const getProductTypeEnumFromId = (productId: string) => {
    if (productId === "158") {
        return ProductTypeRequest.BoostAlert;
    } else if (productId === "1") {
        return ProductTypeRequest.BoostListe;
    } else if (productId === "2") {
        return ProductTypeRequest.BoostExtend;
    } else if (productId === "121") {
        return ProductTypeRequest.AnnonceOr;
    } else if (productId === "123") {
        return ProductTypeRequest.AnnonceArgent;
    } else {
        return ProductTypeRequest.All;
    }
}

export interface Contract extends GetDistributionDetailsResponse {
	marketId: number;
	productId: number;
	marketName: string;
}